import CustomContentApi from '../api/customContentApi';
import { loadCustomContentSuccess, loadCustomContentRequest, loadCustomContentError } from './customContentActions';

export function loadCustomContent(customPageId) {
    return function (dispatch) {
        dispatch(loadCustomContentRequest());
        return CustomContentApi.getPayload(customPageId).then(payload => {
            dispatch(loadCustomContentSuccess(payload));
        }, error => {
            dispatch(loadCustomContentError());
        });
    };
}